import { Button } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import React from 'react';

type AddPerUnitUsageChargeVariantProps = {
  onAddVariant: () => void;
};

export const AddPerUnitUsageChargeVariant: React.FC<AddPerUnitUsageChargeVariantProps> = ({
  onAddVariant,
}) => {
  return (
    <Button onClick={onAddVariant} className="gap-x-2">
      <VyIcon icon="PlusMedium" />
      Add Product Variant
    </Button>
  );
};
